import request from "./request";
//首页列表
export function getList(data) {
    return request({
        url: `https://publicity.cebpubservice.com/sessions/portalSession/attendeeInfoList?${data}`,
        method: "GET",
    });
}
// 获取证书
export function getcertificate(data) {
    return request({
        url: `https://publicity.cebpubservice.com/sessions/portalSession/attendeeInfo/${data}`,
        method: "GET",
    });
}
//记录下载个人报告
export function PersonalReport(id) {
    return request({
        url: `https://publicity.cebpubservice.com/sessions/portalSession/downloadCertificate/${id}`,
        method: "post",
        data: id,
    });
}

// import request from "./request";
// //首页列表
// export function getList(data) {
//     return request({
//         url: `http://47.94.198.176:8889/sessions/portalSession/attendeeInfoList?${data}`,
//         method: "GET",
//     });
// }
// // 获取证书
// export function getcertificate(data) {
//     return request({
//         url: `http://47.94.198.176:8889/sessions/portalSession/attendeeInfo/${data}`,
//         method: "GET",
//     });
// }
// //记录下载个人报告
// export function PersonalReport(id) {
//     return request({
//         url: `http://47.94.198.176:8889/sessions/portalSession/downloadCertificate/${id}`,
//         method: "post",
//         data: id,
//     });
// }